import { t } from 'i18next'

export const placementNamesBestPracticesSchema: TableSchema<TableBestPractices> =
  {
    device: {
      title: t('rm:placements.bestPractices.table.device'),
      render: rowData => <span className="fs-6">{rowData.device}</span>
    },
    context: {
      title: t('rm:placements.bestPractices.table.context'),
      render: rowData => <span className="fs-6">{rowData.context}</span>
    },
    position: {
      title: t('rm:placements.bestPractices.table.position'),
      render: rowData => <span className="fs-6">{rowData.position}</span>
    },
    adType: {
      title: t('rm:placements.bestPractices.table.adType'),
      render: rowData => <span className="fs-6">{rowData.adType}</span>
    },
    name: {
      title: t('rm:placements.bestPractices.table.name'),
      render: rowData => <span className=" fs-6">{rowData.name}</span>
    }
  }
